import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';

import styles from '@/views/components/Alert/Alert.module.scss';

const SimpleAlert = ({variant = 'info', className = '', style, alertContent, closeAction}) => {
	return (
		<Alert 
			onClose={ closeAction }
			severity={ variant }
			className={ `${ styles['custom-alert'] } ${className}` }
			style={ style }
		>
			{alertContent}
		</Alert>
	);
};

SimpleAlert.propTypes = {
	variant: PropTypes.string,
	className: PropTypes.string,
	alertContent: PropTypes.node,
	closeAction: PropTypes.func,
};

export default memo(SimpleAlert);